import { defineComponent as _defineComponent } from 'vue'
import {
  collectionsSearchCatalogResource,
  collectionsSearchCatalogCategoryResource,
} from '@/services/search.service'
import useGlobal from '@composables/useGlobal'


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectionCatalogSearch',
  props: {
  pagination: {
    type: Object,
  },
  cardsWrapperClass: {
    type: String,
  },
  label: {
    type: String,
  },
  query: {
    type: String,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props

const { $t } = useGlobal()

const pluralForms = [
  $t('колекция'),
  $t('колекции'),
  $t('колекций'),
]

const __returned__ = { props, $t, pluralForms, get collectionsSearchCatalogResource() { return collectionsSearchCatalogResource }, get collectionsSearchCatalogCategoryResource() { return collectionsSearchCatalogCategoryResource }, get useGlobal() { return useGlobal } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})